function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import fonts from './fonts';
import borders from './borders';
import radii from './radii';
import elevation from './elevation';
import { hydro2, legacyColors } from '@dfds-ui/colors';
import { spacing } from '@dfds-ui/spacing';
import states from './states';
import breakpoints from './breakpoints'; // const DEPRECATE_LEGACY = false
// const deprecatedColors = (): typeof legacyColors => {
//   const legacy = {}
//   Object.keys(legacyColors).forEach(item =>
//     Object.defineProperty(legacy, item, {
//       get: () => {
//         console.warn(`color key ${item} is deprecated `)
//         return legacyColors[item as keyof typeof legacyColors]
//       },
//     })
//   )
//   return legacy as typeof legacyColors
// }
// const legacy = DEPRECATE_LEGACY ? deprecatedColors() : legacyColors

var colorPalette = hydro2;

var theme = _objectSpread({}, fonts, {
  borders: borders,
  colors: _objectSpread({}, legacyColors, {}, colorPalette),
  spacing: spacing,
  radii: radii,
  elevation: elevation,
  breakpoints: breakpoints,
  states: states
});

export default theme;